import { render, staticRenderFns } from "./StatusByUser.vue?vue&type=template&id=5d42992b&scoped=true"
import script from "./StatusByUser.vue?vue&type=script&lang=js"
export * from "./StatusByUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d42992b",
  null
  
)

export default component.exports